module.exports = __webpack_public_path__ + "static/media/jumbotron__image--11.e67033ea.jpg";